import React from 'react';
import { IItemCustomer } from 'types';
import moment from 'moment';
import Text from 'components/Text/Text';
import style from './AdditionallyInfoView.module.scss';

interface IProps {
	data: IItemCustomer;
}

export const AdditionallyInfoView: React.FC<IProps> = ({
	data: { insertedDate, insertedBy, updatedDate, updatedBy, tips, emailBodyTemplate, ads },
}) => {
	const defaultTips = tips?.split(';')[0];
	const tips1 = tips?.split(';')[1];
	const tips2 = tips?.split(';')[2];
	const tips3 = tips?.split(';')[3];

	return (
		<div className={style.container} data-test="AdditionallyInfoView">
			<div className={style.block}>
				<Text
					className={style.blockName}
					translationNameSpace="listing"
					translationKey="createdLabel"
					theme="neutralLight"
				/>
				{insertedDate ? (
					<Text
						className={style.blockValue}
						translationNameSpace="listing"
						translationKey="createdString"
						components={[<span key="1" className={style.date} />]}
						values={{
							createdAt: moment(insertedDate).format('MM/DD/YYYY h:mm:ss A'),
							createdBy: insertedBy,
						}}
					/>
				) : (
					'-'
				)}
				<Text
					className={style.blockName}
					translationNameSpace="listing"
					translationKey="lastUpdateLabel"
					theme="neutralLight"
				/>
				{updatedDate ? (
					<Text
						className={style.blockValue}
						translationNameSpace="listing"
						translationKey="updatedString"
						components={[<span key="1" className={style.date} />]}
						values={{
							updatedAt: moment(updatedDate).format('MM/DD/YYYY h:mm:ss A'),
							updatedBy: updatedBy,
						}}
					/>
				) : (
					'-'
				)}
			</div>
			<div className={style.block}>
				<Text
					className={style.blockName}
					translationNameSpace="listing"
					translationKey="tipsLabel"
					theme="neutralLight"
				/>
				<Text
					className={style.blockValue}
					translationNameSpace="listing"
					translationKey="tipsString"
					components={[<span key="1" className={style.tipsValue} />]}
					values={{
						defaultTips,
						tips1,
						tips2,
						tips3,
					}}
				/>
				<Text
					className={style.blockName}
					translationNameSpace="listing"
					translationKey="emailBodyTemplateLabel"
					theme="neutralLight"
				/>
				<Text className={style.blockValue} translationKey={emailBodyTemplate} />
				<Text
					className={style.blockName}
					translationNameSpace="listing"
					translationKey="adsRepeatTimeLabel"
					theme="neutralLight"
				/>
				<Text
					className={style.blockValue}
					translationNameSpace="listing"
					translationKey="adsRepeatTimeValue"
					translationOptions={{ ads }}
				/>
			</div>
		</div>
	);
};
